module.exports = __webpack_public_path__ + "static/media/guide_3.189ae6b4.png";